import React from 'react'

import { Performance as PerformanceIcon } from '@factorialco/factorial-one-react/icons/modules'
import { PerformanceTabsDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { buildModuleRoute, buildNavigation } from 'modules/core/lib/react-router'

import competenciesPerformanceRoutes from 'modules/competencies/routes/performance'
import goalsPerformanceRoutes from 'modules/goals/routes/performance'
import reviewsPerformanceRoutes from 'modules/reviews/routes/performance'

const RedirectToRoutePage = React.lazy(
  () => import('modules/performance/pages/RedirectToRoutePage')
)
const RootPage = React.lazy(() => import('modules/performance/pages/RootPage'))

export const performanceRoutes = buildNavigation((navigation) => [
  buildModuleRoute({
    path: navigation.performance.path,
    element: <RootPage />,
    handle: {
      module: 'performance',
      moduleIcon: PerformanceIcon,
      moduleName: () => i18n.t('sidebar.performance'),
      meta: ({ watchQuery }) => {
        return watchQuery({
          query: PerformanceTabsDocument,
        }).map(({ data }) => {
          const canSeeReviews = Boolean(
            data?.performanceReviews?._policies?.sidebarSeePerformanceReviewsSubLevelItem?.can
          )
          const canSeeGoals = Boolean(
            data?.goals?._policies?.sidebarSeePerformanceGoalsSubLevelItem?.can
          )

          return {
            title: i18n.t('sidebar.performance'),
            subNavigation: [
              {
                title: i18n.t('surveys.tabs.reviews'),
                href: navigation.performance.reviews.fullPath(),
                id: navigation.performance.reviews.fullPath(),
                isVisible: canSeeReviews,
              },
              {
                title: i18n.t('surveys.tabs.goals'),
                href: navigation.performance.goals.fullPath(),
                id: navigation.performance.goals.fullPath(),
                isVisible: canSeeGoals,
              },
            ],
          }
        })
      },
    },
    children: [
      {
        index: true,
        element: <RedirectToRoutePage />,
      },
      ...competenciesPerformanceRoutes(navigation),
      ...goalsPerformanceRoutes(navigation),
      ...reviewsPerformanceRoutes(navigation),
    ],
  }),
])
